var g_strType = "";
var g_bRunningInAgentClient = true;
var g_bConsult = false;
var strHandleforSwap;
var SwapReady = false;
var SwapStart = false;
var g_bConsult = "no";
var g_DebugMode = false;
var UriToLoad = "";



// Executes a command, which is actually navigating to a special kind of URL
function execCommand(strCommand)
{
    if (g_DebugMode == true)
    {
        alert("Command to be executed [" + strCommand + "]");
    }

    if (/chrome/.test(navigator.userAgent.toLowerCase()))
    {
        // Fall back to the old method of executing the command in case the
        // browser doesn't support the command yet
        if (typeof window.ExecuteSDKCommand == "undefined")
        {
            // The javascript function window.navigate(xxx) isn't supported by
            // Chrome. Also, there is an issue with Chrome that page navigation
            // must be set at the end of an event so that is why it's delayed
            // Also, commands need to be executed asynchronously. Otherwise,
            // only last message is executed.
            setTimeout(function ()
            {
                window.location.assign("application:" + strCommand);
            }, 300);
        }
        else
        {
            // Call the function that's defined in the browser
            window.ExecuteSDKCommand(strCommand);
        }
    }
    else
    {
        // Fall back to the old method of executing the command in case the
        // browser doesn't support the command yet
        if (typeof external.ExecuteSDKCommand == "unknown")
        {
            window.navigate("application:" + strCommand);
        }
        else
        {
            // Call the function that's defined in the browser
            external.ExecuteSDKCommand(strCommand);
        }
    }
}

// Dial a number. The property added will make it possible to make statistics for this calls.
// Dialing without properties is also possible if statistics are not needed.
function cmdTapiDial(strNumber, strPropertyVal)
{
    var strCommand = "<Command Name='PHONEDOACTION'><Action>HOLD</Action></Command>";
    execCommand(strCommand);

    var strCommand = "<Command Name='PHONEDOACTION'><Action>DIAL</Action><ActionInfo><PhoneNumber>" + strNumber + "</PhoneNumber><CallType>CC</CallType><DialType>TAPI</DialType><Properties><Property><Name><![CDATA[KlantId]]></Name><Value><![CDATA[" + strPropertyVal + "]]></Value><Hidden>NO</Hidden></Property></Properties></ActionInfo></Command>";
    execCommand(strCommand);
}

function cmdTapiDialIvr(strNumber, strBoekingsCode, strPropertyVal)
{
    var strCommand = "<Command Name='PHONEDOACTION'><Action>HOLD</Action></Command>";
    execCommand(strCommand);

    var strCommand = "<Command Name='PHONEDOACTION'><Action>DIAL</Action><ActionInfo><PhoneNumber>" + strNumber + "</PhoneNumber><CallType>CC</CallType><DialType>IVR</DialType><Properties><Property><Name><![CDATA[KlantId]]></Name><Value><![CDATA[" + strPropertyVal + "]]></Value><Hidden>NO</Hidden></Property><Property><Name><![CDATA[Virtueel]]></Name><Value><![CDATA[" + strBoekingsCode + "]]></Value><Hidden>YES</Hidden></Property></Properties></ActionInfo></Command>";
    execCommand(strCommand);
}

function cmdSpeedDialIvr(strNumber, strVirtueelId, strType, strActie)
{
    var strCommand = "<Command Name='PHONEDOACTION'><Action>HOLD</Action></Command>";
    execCommand(strCommand);

    var strCommand = "<Command Name='PHONEDOACTION'><Action>DIAL</Action><ActionInfo><PhoneNumber>" + strNumber + "</PhoneNumber><CallType>CC</CallType><DialType>IVR</DialType><Properties><Property><Name><![CDATA[VirtueelId]]></Name><Value><![CDATA[" + strVirtueelId + "]]></Value><Hidden>NO</Hidden></Property><Property><Name><![CDATA[Type]]></Name><Value><![CDATA[" + strType + "]]></Value><Hidden>YES</Hidden></Property><Property><Name><![CDATA[Actie]]></Name><Value><![CDATA[" + strActie + "]]></Value><Hidden>YES</Hidden></Property></Properties></ActionInfo></Command>";
    execCommand(strCommand);
}

// This function is used to change a page on another tab.
function cmdSwapTabs(strUrl)
{
    UriToLoad = strUrl;

    if (g_DebugMode == true)
    {
        alert("cmdSwapTabs SwapReady = [" + SwapReady + "]");
    }

    if (!SwapReady)
    {
        // First we need the active tab (so the one where the 'click' is done.
        SwapStart = true;
        execCommand("<Command Name='GETACTIVETAB'></Command>");
        // After this we will receive the "event" Application_ActiveTabRetrieved below		
    }
    else
    {
        // Now we need to make the command to change the url of the tab to the one we want.
        var strCommand = "<Command Name='SETSUBTABURI'><SubTabId><![CDATA[" + strHandleforSwap + "]]></SubTabId><Uri><![CDATA[" + UriToLoad + "]]></Uri></Command>";
        //alert(strCommand);
        execCommand(strCommand);
        //SwapReady = false;
        // If desired, the code below sets the focus to that tab.
        strCommand = "<Command Name='ACTIVATESUBTAB'><SubTabId><![CDATA[" + strHandleforSwap + "]]></SubTabId></Command>";
        execCommand(strCommand);
        SwapStart = false;

    }

}

function Application_ActiveTabRetrieved(strGroupID, strActiveTab, strTabType)
{
    // We now have the group in which te active tab is, now we need to know the other tabs in this group (calendar, google maps,...)
    if (SwapStart == true)
    {
        var strCommand = "<Command Name='GETSUBTABS'><MainTabId>" + strGroupID + "</MainTabId></Command>";
        execCommand(strCommand);
        // This will cause the "event" Application_SubTabsRetrieved below
    }
}

function Application_SubTabsRetrieved(strMainTabID, strSubTabIDs, strTabGroupID)
{
    // Now we have all "id's" of the tabs on our group
    if (SwapStart == true)
    {
        var arrHandles = strSubTabIDs.split(";");
        if (g_DebugMode == true)
        {
            alert("strHandleforSwap = [" + arrHandles[4] + "]");
        }

        strHandleforSwap = arrHandles[4]; // Set the tab to be changed to the second one in the group. (e.g. 0:Datagrid, 1:Agenda, 2:Google Maps,3:Medicijnen)
        SwapReady = true;

        // Now we need to make the command to change the url of the tab to the one we want.
        var strCommand = "<Command Name='SETSUBTABURI'><SubTabId><![CDATA[" + strHandleforSwap + "]]></SubTabId><Uri><![CDATA[" + UriToLoad + "]]></Uri></Command>";
        execCommand(strCommand);
        // If desired, the code below sets the focus to that tab.
        strCommand = "<Command Name='ACTIVATESUBTAB'><SubTabId><![CDATA[" + strHandleforSwap + "]]></SubTabId></Command>";
        execCommand(strCommand);

        // Reset the SwapStart
        SwapStart = false;
    }
}

function cmdTapiDialNew(strNumber, strPropertyVal)
{
    var strCommand = "<Command Name='PHONEDOACTION'><Action>DIAL</Action><ActionInfo><PhoneNumber>" + strNumber + "</PhoneNumber><CallType>CC</CallType><DialType>TAPI</DialType><Properties><Property><Name><![CDATA[KlantId]]></Name><Value><![CDATA[" + strPropertyVal + "]]></Value><Hidden>NO</Hidden></Property></Properties></ActionInfo></Command>";
    execCommand(strCommand);
}

function cmdTapiConsult(strNumber, strPropertyVal)
{
    var strCommand = "<Command Name='PHONEDOACTION'><Action>CONSULT</Action><ActionInfo><PhoneNumber>" + strNumber + "</PhoneNumber><CallType>CC</CallType></ActionInfo></Command>";
    execCommand(strCommand);
}

function cmdTapiAuto(strNumber, strPropertyVal)
{
    // getConfig("consult");
    // if (g_bConsult == "yes")
    // {
    //     cmdTapiConsult(strNumber, strPropertyVal);
    // }
    // else
    // {
        cmdTapiDialNew(strNumber, strPropertyVal);
    // }
}

function getConfig(strName)
{
    var strCommand = "<Command Name='GETCONFIG'><Name><![CDATA[consult]]></Name></Command>";
    execCommand(strCommand);
}

function setConfig(strName, strValue)
{
    var strCommand = "<Command Name='SETCONFIG'><Name><![CDATA[" + strName + "]]></Name><Value><![CDATA[" + strValue + "]]></Value></Command>";
    execCommand(strCommand);
}

function Application_ConfigValue(strName, strValue)
{
    //alert("Application_ConfigValue Name = [" + strName + "] Value = [" + strValue + "]");
    if (strName == "consult")
    {
        g_bConsult = strValue;
    }
}
